import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

export interface ButtonIconProps {
	children: ReactNode;
	side: 'left' | 'none' | 'right';
	size: number;
}

interface WrapProps extends Pick<ButtonIconProps, 'side' | 'size'> {}

// Use positive relative to keep the icon+text combination centered. Almost all icons have some
// padding inside the svg. Shift the icon a little bit to account for that.
const Wrap = styled('span')<WrapProps>`
	width: ${props => props.size}px;
	height: ${props => props.size}px;
	position: relative;
	left: ${props => props.side === 'left' && '-3px'};
	right: ${props => props.side === 'right' && '-3px'};
	margin-right: ${props => props.side === 'left' && '3px'};
	margin-left: ${props => props.side === 'right' && '3px'};
	display: flex;
	align-items: center;
	justify-content: center;

	> img {
		width: auto;
		height: auto;
		max-width: 100%;
		max-height: 100%;
	}
`;

const ButtonIcon = ({ children, side, size, ...props }: ButtonIconProps) => (
	<Wrap side={side} size={size}>
		{React.cloneElement(children as ReactElement, {
			size,
			...props,
		})}
	</Wrap>
);

ButtonIcon.defaultProps = {
	side: 'left',
	size: 18,
};

export default ButtonIcon;
